
export class PasswordSearchCriteria {
    public searchTerm: string;
    public selectedTeams: number[];
    public selectedLabels: number[];
    public selectedTimeframe: number;
    public searchFavorite: number = 0;
    public searchOwnership: number = 0;
}